import React, { useState } from 'react';
import "./quizPopup.scss";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Fragment } from 'react';
import Drawer from '@mui/material/Drawer';


function QuizPopup(props) {
    const [quiz, setQuiz] = useState(false);
    const [question, setQuestion] = useState(null)
    const [quizComplete, setQuizComplete] = useState(false);
    const [showExplanation, setShowExplanation] = useState(false);
    const [count, setCount] = useState(0)
    const { activeFeedData, questions, isQuizComplete } = props;
    console.log(activeFeedData, questions)

    const goToQuestion = (el) => {
        setQuiz(true);
        setQuestion(el)
    }

    const selectAnswer = async (qid, aid) => {
        const res = await props.selectAnswer(qid, aid);
        await setQuestion({ ...question, correct: res.payload?.data?.correct, correct_id: res.payload?.data?.correct_id, answer: res.payload?.aid })
        // setQuestion(questions.filter(el => { return el._id === qid })[0])
        // await setQuestion(questions.filter(el => { return el._id === qid })[0])
    }

    const getPrev = () => {
        setCount(count - 1);
        setQuestion(questions[count - 1])
    }

    const getNext = () => {
        setCount(count + 1);
        setQuestion(questions[count + 1])
    }

    const quizSubmit = async (id) => {
        const correctQuestion = questions.filter(el => el.correct);
        let obj = {
            _id: id,
            score: correctQuestion?.length
        }
        await props.quizSubmitted(obj);
        await setQuizComplete(true);
        await setQuiz(false);
        console.log(id);
        let local_data = JSON.parse(localStorage.getItem('time'));
        local_data.r_id = id;
        local_data.type = 'Quiz';
        local_data.viewed = true;
        local_data.total = local_data.total / 1000
        await props.viewAnalytic(local_data);
    }


    return (
        <div className="modal-body" style={{ background: '#fff' }}>
            <div className='test-holder1 text-center'>
                {window.innerWidth > 767 ? !quiz && <div className='sticky-close' onClick={() => {
                    setQuizComplete(false);
                    props.closePopup();
                }}>
                    <img src='/images/close.svg' alt='' />
                </div> :
                    null
                }
                {
                    quiz ?
                        <Fragment>
                            <h1 className='float-left mt-2' style={{ fontSize: 34 }}>{activeFeedData?.title}</h1>

                            {question !== undefined && <div className='col-md-8 offset-md-2' style={{ paddingTop: window.innerWidth > 767 ? '5%' : 100 }}>

                                <p className='question-header'>Question {count + 1}/{questions?.length}</p>
                                <div className='ques-title'>
                                    <small dangerouslySetInnerHTML={{ __html: question?.title }} />
                                </div>
                                <ul className='options'>
                                    {
                                        question?.answers !== undefined && question?.answers.map((ans, index) => {
                                            return (
                                                <li className='row' key={index} style={{ pointerEvents: question.answer !== null ? 'none' : 'auto' }} >
                                                    <div className='col-md-1 col-1'>
                                                        {(question.correct_id === ans._id && question.correct) ? <img src='/images/correct.svg' style={{ verticalAlign: 'middle' }} alt='' /> : question.correct === false && question.answer === ans._id ? <img src='/images/incorrect.svg' style={{ verticalAlign: 'middle' }} alt='' /> : question.correct_id === ans._id ? <img src='/images/correct.svg' style={{ verticalAlign: 'middle' }} alt='' /> : null}
                                                    </div>
                                                    <div className={question.correct_id === ans._id && question.correct ? 'correct option col-md-7 col-7' : question.correct === false && question.answer === ans._id ? 'incorrect option col-md-7 col-7' : question.correct_id === ans._id ? 'correct option col-md-7 col-7' : 'option1 col-md-7 col-7'} onClick={() => selectAnswer(question._id, ans._id)}
                                                        dangerouslySetInnerHTML={{ __html: ans?.title }}
                                                    />

                                                    <div className='col-md-2 col-2' >
                                                        {question.description !== null ? window.innerWidth > 767 && question.correct_id === ans._id ?
                                                            showExplanation ?
                                                                <div className='explanation-popup' >
                                                                    <h1>Explanation</h1>
                                                                    <div className='close-explaination' onClick={() => setShowExplanation(false)}><img src='/images/close.svg' alt='' width='10px' /></div>
                                                                    <div style={{ textAlign: 'left', marginLeft: 5 }} dangerouslySetInnerHTML={{ __html: question.description }}>
                                                                    </div>
                                                                </div> :
                                                                <img src='/images/info-circle.svg' style={{ verticalAlign: 'middle', cursor: 'pointer', pointerEvents: 'auto', marginTop: 5 }} alt='' onClick={(e) => {
                                                                    setShowExplanation(true);
                                                                }} />
                                                            : question.correct_id === ans._id && <img src='/images/info-circle.svg' style={{ verticalAlign: 'middle', cursor: 'pointer', pointerEvents: 'auto', marginTop: 5 }} alt='' onClick={(e) => setShowExplanation(true)} />
                                                            : null
                                                        }
                                                        {
                                                            window.innerWidth < 767 && ['bottom'].map((anchor) => (
                                                                <React.Fragment key={anchor}>
                                                                    <Drawer
                                                                        anchor={anchor}
                                                                        open={showExplanation}
                                                                        className='mobile-drawer'
                                                                    >

                                                                        {
                                                                            showExplanation ?
                                                                                <div style={{ padding: 16 }} >
                                                                                    <h1>Explanation</h1>
                                                                                    <div className='close-explaination' onClick={() => setShowExplanation(false)}><img src='/images/close.svg' alt='' width='12px' /></div>
                                                                                    <small dangerouslySetInnerHTML={{ __html: question?.description }}></small>
                                                                                </div>
                                                                                : null
                                                                        }

                                                                    </Drawer>
                                                                </React.Fragment>))
                                                        }

                                                    </div>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>

                                <div className='fixed-prev mt-4' style={{ marginLeft: window.innerWidth > 767 ? -25 : 5, cursor: 'pointer' }}>
                                    {
                                        count === 0 ?
                                            null :
                                            <div className='prev-quiz' onClick={() => {
                                                getPrev(count)
                                                setShowExplanation(false)
                                            }
                                            } ><img src='/images/left-arrow.png' width={12} alt='' />&nbsp;Prev</div>
                                    }
                                    &nbsp;
                                    {
                                        count + 1 === questions.length ? null :
                                            <div className='next-quiz' onClick={() => {
                                                getNext(count)
                                                setShowExplanation(false)
                                            }
                                            } >Next &nbsp;<img src='/images/right-arrow.png' width={12} alt='' /></div>
                                    }
                                    {count + 1 === questions.length ?
                                        <div className='next-quiz' onClick={() => quizSubmit(activeFeedData?._id)} style={{ display: 'flex', marginLeft: 40, fontWeight: '600' }}>Submit</div>
                                        : null
                                    }
                                </div>
                            </div>}
                        </Fragment>
                        :

                        (isQuizComplete || quizComplete) ?
                            <div className='col-md-6 offset-md-3 d-flex justify-content-center flex-column align-items-center quiz-complete'>

                                <div className='mt-3'>
                                    <img src='/images/happy.gif' width='300px' height='300px' alt='' />
                                </div>
                                <p>Yay! Test Completed</p>
                                <small>Congrats, You have completed your test and your score is</small>
                                <div className='score'>
                                    {questions && questions.filter(el => el.correct)?.length}/{questions.length}
                                </div>
                                <button onClick={() => {
                                    setQuizComplete(false)
                                    props.closePopup()
                                }} className='start-btn'>
                                    Close Test
                                </button>
                                {/* <p onClick={() => props.closeQuizpopup()} >
                                    Exit Test
                                </p> */}

                            </div>
                            :
                            <div className='col-md-6 offset-md-3 d-flex justify-content-center flex-column align-items-center'>

                                <h1>{activeFeedData?.title}</h1>
                                <p>{questions !== undefined && questions?.length} Multiple Choice Question </p>
                                <div className='mt-3'>

                                    <img src='/images/test-image.png' alt='' width={window.innerWidth > 767 ? 451 : 340} />
                                </div>
                                <small className='desc text-center'>
                                    {activeFeedData?.description}
                                </small>
                                <br />
                                <button onClick={() => goToQuestion(questions[0])} className='start-btn'>
                                    Start Test
                                </button>

                            </div>

                }

            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return state
}
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        // selectAnswer
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(QuizPopup)